<template>
	<div>
		<div
			@mouseenter="$emit('mouseenter', $event)"
			@mouseleave="$emit('mouseleave', $event)"
			:class="classes"
			class="toast border-radius margin-top-tiny display-inline-flex margin-right-auto"
		>
			<div v-if="showIcon && toastIcon" class="margin-right-normal line-height-normal">
				<b-icon class="line-height-normal"
					><component class="font-size-xbig" :is="`${toastIcon}`"
				/></b-icon>
			</div>
			<div class="flex-grow margin-right-tiny">
				<p v-if="title" class="semi-bold font-size-xbig bold margin-top-0 margin-botom-normal">
					{{ title }}
				</p>
				<p class="semi-bold font-size-big margin-0">
					{{ message }}
				</p>
				<p
					v-if="description"
					v-html="description"
					class="font-size-bib margin-top-normal margin-bottom-0"
				></p>
				<div class="actions margin-top-normal negative-margin-left-xtiny" v-if="actions">
					<b-button
						link
						class="font-size-big bold padding-0 margin-0"
						color="white"
						v-for="(action, i) in actions"
						:key="i"
						@clickOrEnter="action.callback"
						>{{ action.text }}
						<b-icon>
							<icon-chevron-right />
						</b-icon>
					</b-button>
				</div>
			</div>
			<b-icon
				class="close"
				@keydown.enter.native="$emit('closeToast', $event)"
				@click.native="$emit('closeToast', $event)"
				><icon-clear class="font-size-xbig"
			/></b-icon>
			<div
				v-if="timeout !== false"
				class="timeout"
				:style="`width: ${(timeleft / timeout) * 100}%`"
			></div>
		</div>
	</div>
</template>

<script>
import BIcon from '../components/Icon.vue';
import BButton from '../components/Button.vue';
export default {
	name: 'app-toast-card',
	components: {
		BIcon,
		BButton
	},
	props: {
		title: String,
		message: String,
		description: String,
		timeout: null,
		timeleft: null,
		icon: {
			default: null
		},
		type: String,
		actions: Array
	},
	computed: {
		classes() {
			if (this.type === 'success') return 'bg-green-base white-base padding-big';
			if (this.type === 'danger') return 'bg-red-base white-base padding-big';
			if (this.type === 'neutral') return 'bg-white-base ink-base padding-big';
			else return 'bg-ink-lighter-1 white-base padding-big';
		},
		showIcon() {
			if (this.icon === false) {
				return false;
			}
			return true;
		},
		toastIcon() {
			if (this.icon === null && this.type === 'success') return 'icon-check-circle';
			if (this.icon === null && this.type === 'danger') return 'icon-error';
			return this.icon;
		}
	}
};
</script>

<style lang="scss" scoped>
.toast {
	overflow: hidden;
	box-shadow: 0px 0.9rem 1.2rem 0 rgba(0, 0, 0, 0.14);
	width: auto;
	margin-right: auto;
	max-width: 42rem;
	position: relative;
	@media (max-width: 767px) {
		max-width: calc(100vw - 3.2rem);
	}
}
.close {
	position: absolute;
	padding: 0.4rem;
	top: 1.2rem;
	right: 1.2rem;
	cursor: pointer;
}
.timeout {
	transition: width 0.03s;
	opacity: 0.3;
	height: 0.6rem;
	position: absolute;
	left: 0;
	bottom: 0;
	background: #fff;
}
</style>
